export default function IdentityIcon() {
  return (
    <svg width='34' height='24' viewBox='0 0 53 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.14258 36.9408C8.14258 32.1757 11.1425 29.1758 15.9076 29.1758C20.6727 29.1758 23.6726 32.1757 23.6726 36.9408H8.14258Z'
        fill='#F815A0'
      />
      <path
        d='M15.9071 26.5877C18.7661 26.5877 21.0838 24.2701 21.0838 21.4111C21.0838 18.5521 18.7661 16.2344 15.9071 16.2344C13.0481 16.2344 10.7305 18.5521 10.7305 21.4111C10.7305 24.2701 13.0481 26.5877 15.9071 26.5877Z'
        fill='#F815A0'
      />
      <path
        d='M28.8477 21.4102H44.3777V26.5868H28.8477V21.4102ZM28.8477 31.7635H44.3777V36.9402H28.8477V31.7635Z'
        fill='#F815A0'
      />
      <path
        d='M46.9671 5.87981H33.5465C32.475 2.87215 29.6304 0.703125 26.2604 0.703125C22.8903 0.703125 20.0457 2.87215 18.9742 5.87981H5.55363C2.69869 5.87981 0.376953 8.19896 0.376953 11.0565V42.1166C0.376953 44.9715 2.69869 47.2932 5.55363 47.2932H46.9671C49.822 47.2932 52.1437 44.9715 52.1437 42.1166V11.0565C52.1437 8.19896 49.822 5.87981 46.9671 5.87981ZM26.2604 5.87981C27.6865 5.87981 28.8487 7.04197 28.8487 8.46815C28.8487 9.89432 27.6865 11.0565 26.2604 11.0565C24.8342 11.0565 23.672 9.89432 23.672 8.46815C23.672 7.04197 24.8342 5.87981 26.2604 5.87981ZM5.55363 42.1166V11.0565H18.9742C20.0457 14.0641 22.8903 16.2332 26.2604 16.2332C29.6304 16.2332 32.475 14.0641 33.5465 11.0565H46.9671L46.9697 42.1166H5.55363Z'
        fill='#F815A0'
      />
    </svg>
  )
}
